document.documentElement.classList.add('euro-js');

const reveal = () => {
  const elements = document.querySelectorAll('[data-euro-reveal]:not(.is-visible)');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  elements.forEach((element) => observer.observe(element));
};

document.addEventListener('DOMContentLoaded', reveal);
document.addEventListener('shopify:section:load', reveal);

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('[data-euro-filter]') : null;
  if (!(link instanceof HTMLAnchorElement)) return;

  const detail = {
    collection: link.dataset.collectionHandle || '',
    product_type: link.dataset.filterValue || 'all',
    destination: link.href,
  };

  window.dataLayer?.push({ event: 'euro_collection_filter_click', ...detail });
  window.Shopify?.analytics?.publish?.('euro_collection_filter_click', detail);
});
